import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import Image from './Image';

const schema: JSONSchema7 = {
    title: 'Image',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        altText: {
            type: 'string',
            title: 'Alt Text',
            default: 'image',
        },
        isLink: {
            type: 'boolean',
            description: 'Is Link',
            default: false,
            title: 'Is Link',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        isLink: {
            oneOf: [
                {
                    properties: {
                        isLink: { enum: [true] },
                        imageLink: {
                            type: 'string',
                            title: 'Image Link',
                            description: 'URL for the image',
                        },
                    },
                    required: ['imageLink'],
                },
                {
                    properties: {
                        isLink: { enum: [false] },
                        fileName: {
                            type: 'string',
                            title: 'File Name',
                            description: 'File name of the image in the repo',
                        },
                        fileType: {
                            type: 'string',
                            enum: ['png', 'jpg', 'svg'],
                            title: 'File Type',
                            default: 'png',
                        },
                    },
                    required: ['fileName', 'fileType'],
                },
            ],
        },
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default:
                                // eslint-disable-next-line max-len
                                'return (data) => { return {image} }',
                        },
                    },
                },
                {
                    properties: {
                        isTransformData: { enum: [false] },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['altText', 'isLink', 'imageLink', 'fileName', 'fileType'],
        'Transform Data': ['isTransformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    altText: {
        'ui:widget': 'ResourcePicker',
    },
    isLink: {
        'ui:widget': 'CustomCheckbox',
    },
    imageLink: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    fileName: {
        'ui:placeholder': 'logo-en',
        'ui:widget': 'CustomTextInput',
    },
    fileType: {
        'ui:widget': 'CustomSelect',
    },
    functionToTransform: { 'ui:widget': 'JSEditor' },
};

const ImageWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: Image,
    id: 'Image',
    group: 'graphics',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ImageWidget;
